import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { SaveButton, accessibilityNotificationsEmitter } from '../../common';
import { tenantHelpers } from '../../tenantInfo';
import defaultStyle from './upload-logo.component.style.js';
import { toastr } from 'react-redux-toastr';
import './upload-logo.component.scss';

const clearText = "File selection cleared";

export class UploadLogoComponent extends Component {
  constructor(props){
    super(props);

    this.state = {
        imageSrc: null,
        canSave: false
    }
  }

  componentDidMount() {
    this.clearLogoData();
  }

  componentWillUnmount() {
    this.clearLogoData();
  }

  handleInput(e) {
    const { onAddLogoData, onAddLogoContent } = this.props;

    if ( e.target.files[0].type.indexOf("image") === -1) {
      toastr.error('Invalid Logo Selection', 'Please select a valid image file.');
      this.clearLogoData();

      accessibilityNotificationsEmitter.assertive(clearText);
    } else if (e.target.files[0].size > 6291456) {
      toastr.error('Invalid Logo Selection', 'Maximum logo size is 6MB. Please make another selection.');
      this.clearLogoData();
      accessibilityNotificationsEmitter.assertive(clearText);
    } else {
      // add everything to the store except for the file contents
      onAddLogoData(e.target.files[0].name, e.target.files[0].type, e.target.files[0].size);

      var reader = new FileReader();
      reader.onload = ( f => {
        this.setState({imageSrc: f.target.result, canSave: true});
        // add the file contents to the store
        onAddLogoContent( f.target.result );
      });

      reader.readAsDataURL(e.target.files[0]);
    }
  }

  saveButtonClicked(e) {
    const { onSaveLogo } = this.props;
    onSaveLogo()
      .then(val => {
        toastr.success('Success', 'Logo Saved');
        this.clearLogoData();
      })
      .catch(err => {
        toastr.error(err.errorCode, err.errorMessage);
      });

    this.setState({imageSrc: null, canSave: false});
  }

  clearButtonClicked(e) {
    this.clearLogoData();
    accessibilityNotificationsEmitter.assertive(clearText);
  }

  clearLogoData() {
    const { onAddLogoData, onAddLogoContent } = this.props;
    onAddLogoData( null, null, null);
    onAddLogoContent(null);
    document.getElementById('logo-form').reset();
    this.setState({imageSrc: '//:0', canSave: false});
  }

  render() {
    const { css, newLogo } = this.props;
    const isLogoSaving = !!newLogo && newLogo.isFetching;

    const logoDisplay = !!this.state.imageSrc && this.state.imageSrc !== '//:0' ?
      <div id="logo-preview-container" className="logo-upload-container">
        <span className="logo-upload-prefix"></span>
        <img className="logo-upload" alt={`${tenantHelpers.getProductName()} upload`} src={this.state.imageSrc} />
      </div>:
      <br/>;

    return <div>
      <hr/>
      <h3 className={css.heading}>
        Upload Logo
      </h3>
      <form id="logo-form">
        <input
          id="logo-input"
          className={'validated-input'}
          type="file"
          accept={"image/*"}
          onChange={e => this.handleInput(e)} />
        { logoDisplay }
        <div className="actions">
          <button
            type="button"
            disabled={this.state.canSave ? false : true}
            className={css.clearLogoButton}
            onClick={e => this.clearButtonClicked(e)}
            aria-label='Clear Selection'>
            Clear Selection
          </button>
          <SaveButton
            id="save"
            text={"Use New Logo"}
            disabled={this.state.canSave ? false : true}
            saving={isLogoSaving}
            onSave={e => this.saveButtonClicked(e)}/>
        </div>
      </form>
      <br/>
      <hr/>
    </div>;

  }
}

UploadLogoComponent.propTypes = {
  onAddLogoData: PropTypes.func.isRequired,
  onAddLogoContent: PropTypes.func.isRequired,
  onSaveLogo: PropTypes.func.isRequired,
  newLogo: PropTypes.object,
  oldLogo: PropTypes.string
};

export default styleable(defaultStyle) (UploadLogoComponent);
